import { NodeElement } from './node-element';

export class NodeLeaf extends NodeElement {

}
